import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import Landing from './pages/Landing'
import Help from './pages/Help'
import Overlay from './pages/Overlay'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/help" element={<Help />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/overlay/:broadcasterLogin" element={<Overlay />} />
      </Routes>
      <Analytics />
    </BrowserRouter>
  </React.StrictMode>
)